import React, { useEffect, useRef, useState } from 'react';
import { loadScenarios, isUserScenario } from '../core/storage.js';
import { ScriptStudio } from './ScriptStudio.jsx';
import { PreparedLibrary } from './PreparedLibrary.jsx';

// Selection stays inside Director setup. Parsing and persistence belong to the
// existing ScriptStudio and library modules.
export function ScenePicker({ initialTab = 'qline', hosted = false, onChoose, onClose }) {
  const [tab, setTab] = useState(initialTab);
  const dialog = useRef(null);
  useEffect(() => { dialog.current?.showModal(); }, []);
  const scripts = loadScenarios().filter(scene => tab === 'mine' ? isUserScenario(scene.id) : !isUserScenario(scene.id));
  const localScripts = <>
    <div className="picker-scenes">{scripts.map(scene => <article className="surface" key={scene.id}>
      <h3>{scene.title}</h3><p>{scene.logline}</p><small>{scene.characters.length} actors · {scene.duration || scene.estimatedTime || 'About ' + Math.max(1, Math.ceil(scene.cues.length / 4)) + ' minutes'}</small>
      <button type="button" className="button primary" onClick={() => onChoose(scene)}>{hosted ? 'Choose script only' : 'Choose this scene'}</button>
    </article>)}</div>
    {!scripts.length && <p>No local scripts yet. Choose Upload Script to add one.</p>}
  </>;
  return <dialog ref={dialog} className="scene-picker" aria-labelledby="scene-picker-title" onCancel={onClose}>
    <div className="picker-heading"><h2 id="scene-picker-title">Choose what to rehearse</h2><button type="button" className="button secondary" onClick={onClose}>Close</button></div>
    <div className="picker-tabs" aria-label="Scene sources">
      <button type="button" aria-pressed={tab === 'qline'} onClick={() => setTab('qline')}>QLine Library</button>
      <button type="button" aria-pressed={tab === 'mine'} onClick={() => setTab('mine')}>My Library</button>
      <button type="button" aria-pressed={tab === 'upload'} onClick={() => setTab('upload')}>Upload Script</button>
    </div>
    {tab === 'upload' ? <><p>Import PDF, DOCX, TXT or Markdown. Your original text and review stay in the existing local Script Studio.</p><ScriptStudio onSaved={() => {}} onDirect={onChoose} setup /></> : <>
      {hosted ? <>
        <PreparedLibrary key={tab} initialScope={tab === 'mine' ? 'private' : 'catalog'} onDirect={onChoose} />
        <details className="saved-audio-picker"><summary>Scripts on this device · audio needs preparation</summary><p>These script-only copies do not include saved voices or audio. Choose a saved scene above to use its prepared audio.</p>{localScripts}</details>
      </> : localScripts}
    </>}
  </dialog>;
}
